.file-input-wrapper{width:100%}.file-input-wrapper mat-form-field{width:100%}.file-button{margin-right:5px}.file-name-input{width:100%;cursor:pointer}
/*# sourceMappingURL=file-input.component-6GNCGU2K.css.map */
